import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SelectMark } from '../Icons';
import * as Styles from './styles';
export function Tag({ as, startAdornment, endAdornment = _jsx(SelectMark, {}), children, ...rest }) {
    const asTag = as || 'button';
    return (_jsxs(Styles.Button, { as: asTag, ...rest, children: [startAdornment && _jsx(Styles.Adornment, { children: startAdornment }), _jsx(Styles.Label, { children: children }), endAdornment && _jsx(Styles.Adornment, { children: endAdornment })] }));
}
//# sourceMappingURL=index.js.map